import axios from 'axios'
import store from '@/store'
import { getToken, removeToken } from '@/utils/auth'
import constants from './constants'

// create an axios instance "http://localhost:8000/api"
const baseUrl = constants.BASE_API; //"https://api.meet.confhub.live/api"
const service = axios.create({
  baseURL: baseUrl, // base api url
  timeout: 50000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['Authorization'] = 'Bearer ' + getToken()
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
   const data = response.data
    switch (data.status) {
      case 'success':
        return Promise.resolve(response)
      case 'failed':
        return Promise.reject(data.message)
      default:
        if (response.status === 200) {
          return Promise.resolve(response)
        } else {
          return Promise.reject('Server error, please try again.')
        }
    }
    // return response
  },
  error => {
    if(error.response.status == 401){
      removeToken();
      window.location.href = '/user/login';
    }
    return Promise.reject(error.message)
  }
)

export default service
